import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({name: 'sanitizeHtml'})
export class HtmlSanitizer implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    // DOMPurify config:
    //  - Keeps <style> tags
    //  - Keeps inline style="" attributes
    //  - Removes <script> and dangerous stuff
    const cleanHtml = DOMPurify.sanitize(value, {
      ADD_TAGS: ['style'],     // allow <style> blocks
      ADD_ATTR: ['style'],     // allow inline style="" attributes
      FORBID_TAGS: ['script']  // explicitly forbid <script>
      // keep default safe behavior for everything else
    });

    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }
}
